
export const dateParcer = (data) =>{
    let months_arr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    let days_arr = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    let date = new Date(data);
    let year = date.getFullYear();
    let month = months_arr[date.getMonth()];
    let numdate = date.getDate();
    let day = days_arr[date.getDay()];
return `${day},${month} ${numdate},${year}`
}